import { createRouter, createWebHistory } from "vue-router";
import Home from "../views/Home.vue";
import { supabase } from "../supabase";

const routes = [
  {
    path: "/",
    name: "Home",

    beforeEnter: (to, from, next) => {
      document.title = "Kaado"
      if (supabase.auth.currentUser) {
        if (supabase.auth.currentUser.aud) {
          next({
            path: "/dashboard",
          });
        } else {
          next();
        }
      } else {
        next();
      }
    },
    component: Home,
  },
  {
    path: "/login",
    name: "Login",
    // if user is logged in, redirect to dashboard

    beforeEnter: (to, from, next) => {
      document.title = "Kaado | Login"
      if (supabase.auth.currentUser) {
        if (supabase.auth.currentUser.aud) {
          next({
            path: "/dashboard",
          });
        } else {
          next();
        }
      } else {
        next();
      }
    },
    component: () => import("../views/Login.vue"),
  },
  {
    path: "/register",
    name: "Register",
    beforeEnter: (to, from, next) => {
      document.title = "Kaado | Register"
      if (supabase.auth.currentUser) {
        if (supabase.auth.currentUser.aud) {
          next({
            path: "/dashboard",
          });
        } else {
          next();
        }
      } else {
        next();
      }
    },
    component: () => import("../views/Register.vue"),
  },
  {
    path: "/dashboard",
    name: "Dashboard",
    // replace document.title

    // if user is not logged in, redirect to login
    beforeEnter: (to, from, next) => {
      document.title = "Kaado | Dashboard"
      if (supabase.auth.currentUser) {
        if (supabase.auth.currentUser.aud) {
          next();
        } else {
          next("/register");
        }
      } else {
        next("/register");
      }
    },
    component: () => import("../views/Dashboard.vue"),
  },
  {
    path: "/collection",
    name: "Collection",
    // if user is not logged in, redirect to login
    beforeEnter: (to, from, next) => {
      document.title = "Kaado | Collection"
      if (supabase.auth.currentUser) {
        if (supabase.auth.currentUser.aud) {
          next();
        } else {
          next("/register");
        }
      } else {
        next("/register");
      }
    },
    component: () => import("../views/Collection.vue"),
  },
  {
    path: "/preview/:id",
    name: "CollectionPreview",
    component: () => import("../views/CollectionPreview.vue"),

  },
  {
    path: "/queue",
    name: "Queue",
    // if user is not logged in, redirect to login
    beforeEnter: (to, from, next) => {
      document.title = "Kaado | Queue"
      if (supabase.auth.currentUser) {
        if (supabase.auth.currentUser.aud) {
          next();
        } else {
          next("/register");
        }
      } else {
        next("/register");
      }
    },
    component: () => import("../views/Queue.vue"),
  },
  {
    path: "/profile",
    name: "Profile",
    // if user is not logged in, redirect to login
    beforeEnter: (to, from, next) => {
      document.title = "Kaado | Profile"
      if (supabase.auth.currentUser) {
        if (supabase.auth.currentUser.aud) {
          next();
        } else {
          next("/register");
        }
      } else {
        next("/register");
      }
    },
    component: () => import("../views/Profile.vue"),
  },

  {
    path: "/discover",
    name: "Discover",
    // if user is not logged in, redirect to login
    beforeEnter: (to, from, next) => {
      document.title = "Kaado | Discover"
      if (supabase.auth.currentUser) {
        if (supabase.auth.currentUser.aud) {
          next();
        } else {
          next("/register");
        }
      } else {
        next("/register");
      }
    },
    component: () => import("../views/Discover.vue"),
  },
  {
    path: "/pricing",
    name: "Pricing",
    component: () => import("../views/Pricing.vue"),
  },
  {
    path: "/about",
    name: "About",
    component: () => import("../views/About.vue"),
  },
  {
    path: "/float",
    name: "Float",
    beforeEnter: (to, from, next) => {
      document.title = "Kaado | Float"
      if (supabase.auth.currentUser) {
        if (supabase.auth.currentUser.aud) {
          next();
        } else {
          next("/register");
        }
      } else {
        next("/register");
      }
    },
    component: () => import("../views/Float.vue"),
  },
  {
    path: "/tags",
    name: "Tags",
    beforeEnter: (to, from, next) => {
      document.title = "Kaado | Tags"
      if (supabase.auth.currentUser) {
        if (supabase.auth.currentUser.aud) {
          next();
        } else {
          next("/register");
        }
      } else {
        next("/register");
      }
    },
    component: () => import("../views/Tags.vue"),
  },
  {
    path: "/connect",
    name: "Connect",
    beforeEnter: (to, from, next) => {
      document.title = "Kaado | Connect"
      if (supabase.auth.currentUser) {
        if (supabase.auth.currentUser.aud) {
          next();
        } else {
          next("/register");
        }
      } else {
        next("/register");
      }
    },
    component: () => import("../views/Connect.vue"),
  },
  // split

  {
    path: "/split/:id",
    name: "Split",
    component: () => import("../views/Split.vue"),
    props: true
  },
  {
    path: "/contact",
    name: "Contact",
    component: () => import("../views/Contact.vue"),
  },
  {
    path: "/resetPassword",
    name: "ResetPassword",
    component: () => import("../views/ResetPassword.vue"),
  },
  {
    path: '/:pathMatch(.*)*',
    component: () => import("../views/Home.vue"),
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

export default router;
